function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M20 6 9 17l-5-5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </svg>
  );
}

function PendingIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="5" fill="currentColor" />
    </svg>
  );
}

export default function StepItem({
  title,
  meta,
  isCompleted,
  isCurrent,
  isLast,
}) {
  const stateClassName = isCompleted ? 'is-completed' : isCurrent ? 'is-current' : 'is-pending';

  return (
    <div className={`tracking-step-item ${stateClassName}`}>
      <div className="tracking-step-rail" aria-hidden="true">
        <span className="tracking-step-icon">
          {isCompleted ? <CheckIcon /> : <PendingIcon />}
        </span>
        {!isLast && <span className="tracking-step-line" />}
      </div>

      <div className="tracking-step-copy">
        <p className="tracking-step-title">{title}</p>
        {meta ? <p className="tracking-step-meta">{meta}</p> : null}
      </div>
    </div>
  );
}


